import React from "react";
import {
  Chit,
  Container,
  Icon,
  IconList,
  Layout,
  Padding,
  Text,
} from "@kidslivesafe/sc-react";

interface ProfileCardProps {
  name: string;
  location?: string | null;
  showStatus?: boolean;
  statusText?: string;
  statusColor?: "red" | "green" | "yellow" | "grey";
}

const ProfileCard: React.FC<ProfileCardProps> = ({
  name,
  location,
  showStatus = false,
  statusText = "",
  statusColor = "green",
}) => {
  return (
    <Container
      altColor="selected"
      border
      borderColor="primary"
      bodyBorderRadius
    >
      <Padding space="sm">
        <Layout
          type="flex"
          flexProps={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Layout type="flex" flexProps={{ gap: "sm", alignItems: "center" }}>
            <Icon
              name={IconList.IconShield}
              size={32}
              iconColor="var(--sc-text-color-primary)"
            />
            <Layout type="flex" flexProps={{ direction: "column" }}>
              <Text fontWeight="semibold">{name}</Text>
              {location ? (
                <Text size="sm" color="dark-gray">
                  {location}
                </Text>
              ) : null}
            </Layout>
          </Layout>
          {showStatus && statusText ? (
            <Chit chitText={statusText} dotColor={statusColor} />
          ) : null}
        </Layout>
      </Padding>
    </Container>
  );
};

export default ProfileCard;
